import { Link } from "react-router-dom";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { products, categories } from "@/mocks/products";
import ProductCard from "@/pages/products/components/ProductCard";

const FeaturedProducts = () => {
  const { t } = useTranslation();

  const preview = useMemo(
    () =>
      categories
        .filter((c) => c.id !== "all")
        .map((c) => products.find((p) => p.category === c.id))
        .filter((p): p is (typeof products)[number] => Boolean(p)),
    [],
  );

  return (
    <section className="py-14 md:py-24 bg-white">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 md:mb-12">
          <div>
            <p className="text-amber-700 text-xs font-semibold tracking-widest uppercase mb-3">
              {t("home.featured.kicker")}
            </p>
            <h2 className="text-3xl md:text-5xl font-bold text-stone-900">
              {t("home.featured.heading")}
            </h2>
            <p className="text-stone-500 text-sm mt-3 max-w-xl">
              {t("home.featured.description")}
            </p>
          </div>
          <Link
            to="/products"
            className="inline-flex items-center gap-2 text-stone-600 hover:text-stone-900 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("cta.viewAll")} <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6" data-product-shop>
          {preview.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
